/* eslint-disable no-shadow,react-hooks/exhaustive-deps,no-void */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import axios from "axios";
import { message, Form } from "antd";

import { fetchChargesMass, clearMassCharges } from "../../store/slices/charges";
import { fetchServiceTypes } from "../../store/slices/services";
import {
  fetchPaymentType,
  fetchRateModes,
  fetchRateType,
  fetchServiceMode,
} from "../../store/slices/rtkDictionaries";
import Charges from "../../components/Charges/Charges";
import { getChargesRoute } from "../../lib/routes/charging";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import { agreementsSearchActions } from "../../store/slices/agreementsSearch/agreementsSearch";

const ChargesContainer = () => {
  const nowDate = moment();
  const firstDayOfCurrentMonth = moment().startOf("month");
  const firstDayOfPreviousMonth = moment().subtract(1, "months").startOf("month");
  const lastDayOfPreviousMonth = moment().subtract(1, "months").endOf("month");
  const chargesData = useSelector((state) => state.charges.chargesMass);
  const [data, setData] = useState("");
  const [checked, setChecked] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();
  const localStore = JSON.parse(sessionStorage.getItem("chargeFilters"));
  const localStoreChargeParams = localStore?.chargeParams;
  const dispatch = useDispatch();

  const initialClientTypeState = localStore ? localStoreChargeParams?.clientType : "ORGANIZATION";

  const [clientType, setClientType] = useState(initialClientTypeState);

  // Очистка списка начислений по выходу
  useEffect(
    () => () => {
      dispatch(clearMassCharges());
    },
    []
  );

  useEffect(() => {
    const handler = () => {
      // Важно: это вызовется при перезагрузке, закрытии вкладки, и навигации на внешний сайт
      dispatch(agreementsSearchActions.cleanAccounts());
      resetSearchCharges();
    };

    window.addEventListener("beforeunload", handler);

    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, []);

  const chargesSearchParams = {
    accountId: localStore ? localStoreChargeParams?.accountId : null,
    accountIds: localStore ? localStoreChargeParams?.accountIds : undefined,
    page: localStore ? localStoreChargeParams?.page : 0,
    size: localStore ? localStoreChargeParams?.size : 20,
    rateTypeId: localStore ? localStoreChargeParams?.rateTypeId : null,
    clientFullName: localStore ? localStoreChargeParams?.clientFullName : "",
    rateModeId: localStore ? localStoreChargeParams?.rateModeId : null,
    serviceTypeName: localStore ? localStoreChargeParams?.serviceTypeName : [],
    unitsFrom: localStore ? localStoreChargeParams?.unitsFrom : null,
    unitsTo: localStore ? localStoreChargeParams?.unitsTo : null,
    chargeAmountFrom: localStore ? localStoreChargeParams?.chargeAmountFrom : null,
    chargeAmountTo: localStore ? localStoreChargeParams?.chargeAmountTo : null,
    chargeDate: [
      localStore ? moment(localStoreChargeParams?.chargeDateFrom) : firstDayOfCurrentMonth,
      localStore ? moment(localStoreChargeParams?.chargeDateTo) : nowDate,
    ],
    chargePeriod: [
      localStore ? moment(localStoreChargeParams?.chargePeriodFrom) : firstDayOfPreviousMonth,
      localStore ? moment(localStoreChargeParams?.chargePeriodTo) : lastDayOfPreviousMonth,
    ],
    chargeDateFrom: localStore ? localStoreChargeParams?.chargeDateFrom : "",
    chargeDateTo: localStore ? localStoreChargeParams?.chargeDateTo : "",
    chargePeriodFrom: localStore
      ? localStoreChargeParams?.chargePeriodFrom
      : firstDayOfPreviousMonth,
    chargePeriodTo: localStore ? localStoreChargeParams?.chargePeriodTo : lastDayOfPreviousMonth,
    invoiceExtNum: localStore ? localStoreChargeParams?.invoiceExtNum : "",
    invoiceDateFrom: localStore ? localStoreChargeParams?.invoiceDateFrom : "",
    invoiceDateTo: localStore ? localStoreChargeParams?.invoiceDateTo : "",
    billNumber: localStore ? localStoreChargeParams?.billNumber : null,
    billAmountFrom: localStore ? localStoreChargeParams?.billAmountFrom : null,
    billAmountTo: localStore ? localStoreChargeParams?.billAmountTo : null,
    billDateFrom: localStore ? localStoreChargeParams?.billDateFrom : "",
    billDateTo: localStore ? localStoreChargeParams?.billDateTo : "",
    billPeriodFrom: localStore ? localStoreChargeParams?.billPeriodFrom : "",
    billPeriodTo: localStore ? localStoreChargeParams?.billPeriodTo : "",
    isAdjustment: localStore ? localStoreChargeParams?.isAdjustment : null,
    "subscriber.externalId": localStore ? localStoreChargeParams?.["subscriber.externalId"] : null,
    "organization.property.stringValue": localStore
      ? localStoreChargeParams?.["organization.property.stringValue"]
      : null,
  };

  const initialParamsState = {
    ...chargesSearchParams,
    chargeDateFrom: toHttpFormatStartOfDay(chargesSearchParams.chargeDate[0]),
    chargeDateTo: toHttpFormatEndOfDay(chargesSearchParams.chargeDate[1]),
    chargePeriodFrom: toHttpFormatStartOfDay(chargesSearchParams.chargePeriod[0]),
    chargePeriodTo: toHttpFormatEndOfDay(chargesSearchParams.chargePeriod[1]),
    chargeDate: "",
    chargePeriod: "",
  };

  const [chargeParams, setChargeParams] = useState(initialParamsState);

  const displayError = () => {
    message.error({
      content: "Ошибка загрузки начислений. Попробуйте позже",
      style: {
        marginTop: "15vh",
      },
    });
  };

  const fetchChargesAll = () => {
    const url = getChargesRoute({ ...chargeParams, size: 1 });
    return axios(url)
      .then(({ data }) => {
        const { totalElements } = data; // получение общего числа начислений
        if (totalElements) {
          const url2 = getChargesRoute({ ...chargeParams, size: totalElements });
          return axios(url2) // получение всех начислений
            .then(({ data }) => data.content)
            .catch((e) => {
              displayError();
              throw new Error(e);
            });
        }
        return null;
      })
      .catch((e) => {
        displayError();
        throw new Error(e);
      });
  };

  const fetchCharges = (values) => {
    setChecked(false);
    dispatch(fetchChargesMass(values)).then(() => {
      sessionStorage.removeItem("chargeFilters");
    });
  };

  useEffect(() => {
    setData(chargesData?.content);
  }, [chargesData]);

  useEffect(() => {
    dispatch(fetchServiceMode());
    dispatch(fetchServiceTypes());
    dispatch(fetchPaymentType());
    dispatch(fetchRateType());
    dispatch(fetchRateModes());
  }, []);

  const toggleZeroCharges = (e) => {
    setChecked(e.target.checked);
    const filteredZeroCharges = chargesData?.content.filter((item) => item.chargeAmount !== 0);
    setData(e.target.checked ? filteredZeroCharges : chargesData?.content);
  };

  const handlePageSize = (field, value) => {
    switch (field) {
      case "size":
        setChargeParams({ ...chargeParams, size: Number(value), page: 0 });
        fetchCharges({ ...chargeParams, size: Number(value), page: 0 });
        break;
      case "page":
        setChargeParams({ ...chargeParams, page: Number(value) - 1 });
        fetchCharges({ ...chargeParams, page: Number(value) - 1 });
        setSelectedRowKeys([]);
        break;
      default:
        break;
    }
  };

  const handleSearchCharges = (values, clientTypeValue) => {
    setChargeParams(values);
    setClientType(clientTypeValue);
    fetchCharges(values);
  };

  const getValueChargesPagingAndFilters = (field) => chargeParams[field];

  const resetSearchCharges = () => {
    sessionStorage.removeItem("chargeFilters");
    form.setFieldsValue(chargesSearchParams);
    setChargeParams(initialParamsState);
    setClientType(initialClientTypeState);
    dispatch(clearMassCharges());
    dispatch(agreementsSearchActions.cleanAccounts());
  };

  return (
    <div className="container_height">
      <Charges
        data={data}
        checked={checked}
        chargesData={chargesData}
        chargesSearchParams={chargesSearchParams}
        getValueChargesPagingAndFilters={getValueChargesPagingAndFilters}
        resetSearchCharges={resetSearchCharges}
        handleSearchCharges={handleSearchCharges}
        toggleZeroCharges={toggleZeroCharges}
        handlePageSize={handlePageSize}
        form={form}
        chargeParams={chargeParams}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        fetchChargesAll={fetchChargesAll}
        clientType={clientType}
        setClientType={setClientType}
      />
    </div>
  );
};

export default ChargesContainer;
